import React from 'react';
import ServiceDetail from '../Components/ServiceComponent/ServiceDetail';
import Header from '../Components/GlobalComponent/Header';
import Footer from '../Components/GlobalComponent/Footer';

const ServicePage = () => {
    return (
        <div>
            <Header />
            <ServiceDetail />
            <Footer />
        </div>
    );
};

export default ServicePage; 